// Copyright (c) 2021 Uber Technologies, Inc.

export const DEFAULT_CLOUD_PROVIDER = 'dropbox'

export const CLOUD_PROVIDERS = [
  // new DropboxProvider(DROPBOX_CLIENT_ID, DROPBOX_CLIENT_NAME),
  // new CartoProvider(CARTO_CLIENT_ID),
]

export function getCloudProvider(providerName) {
  const cloudProvider = CLOUD_PROVIDERS.find((provider) => provider.name === providerName)
  if (!cloudProvider) {
    throw new Error(`Unknown cloud provider ${providerName}`)
  }
  return cloudProvider
}
